
import React from 'react';

const PlateUnderline = () => {
	return (
		<svg
			xmlns='http://www.w3.org/2000/svg'
			width='32'
			height='32'
			fill='none'
			viewBox='0 0 32 32'
		>
			<path
				fill='#2d2d2d'
				d='M8 16c0 5.51 4.49 10 10 10 3.46 0 6.62-1.75 8.47-4.68l-1.69-1.07A7.967 7.967 0 0118 24c-4.41 0-8-3.59-8-8H8zM18 8c1.78 0 3.46.57 4.86 1.65l1.22-1.59A9.899 9.899 0 0018 6c-2.73 0-5.27 1.08-7.17 3.03l1.43 1.39A7.954 7.954 0 0118 8z'
			></path>
			<path
				fill='#2d2d2d'
				d='M7 26V14h1c1.1 0 2-.9 2-2V6H8v6H7V6H5v6H4V6H2v6c0 1.1.9 2 2 2h1v12h2zM29 6c-1.11 0-4 .81-4 4.5V17c0 .55.45 1 1 1h2v8h2V7c0-.55-.45-1-1-1zm-1 10h-1v-5.5c0-1.29.49-1.91 1-2.22V16zM18 20c-2.21 0-4-1.79-4-4h-2c0 3.31 2.69 6 6 6s6-2.69 6-6-2.69-6-6-6v2c2.21 0 4 1.79 4 4s-1.79 4-4 4zM29 30H6v2h23v-2z'
			></path>
		</svg>
	);
};

export default PlateUnderline;
